/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledUsabilityAndSatisfaction = styled.section`
  height: 85vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & > div {
    width: 100%;
    max-width: 100% !important;
    height: 100%; 
  }
  @media screen and (min-width: 768px) {
    height: 580px;
    width: 768px;
    /* align-items: center; */
  }
  & .text-intro-survaey {
    flex: 0 1 auto;
  }
  & .container-question {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    padding: 1rem 0rem;
    justify-content: flex-start;
  }
  & .ipunt-comment-survey {
    background-color: yellow !important;
    width: 200px !important;
  }
`;

export const StyledWraperIconsSurvey = styled.article`
  margin-top: 24px;
  margin-bottom: .5rem;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  @media screen and (min-width: 768px) {
    grid-column-gap: 2rem;
  }
  & div {
    flex: 1 1 auto;
    width: max-content;
  }
  & > div img {
    width: 40px;
    @media screen and (min-width: 768px) {
      width: 50px;
    }
  }
`;
